import { identify, $client, ready, initializeFx } from './client'

export { createFlag } from './flag'
export { watchFlag } from './watch'
export { Darkly } from './Darkly'

export const $$darkly = { identify, $client, ready, initializeFx }
